import React, { useMemo } from 'react';
import BaseSelectBox from 'components/atoms/base-select-box';
import { clinicInvoiceBillingTypesDataSource } from 'infrastructure/data-sources/clinic-invoice-billing-types';

import type { IClinicInvoiceBillingTypeItem } from 'infrastructure/data-sources/clinic-invoice-billing-types';
import type {
  IBaseSelectBoxOption,
  IBaseSelectBoxProps,
} from 'components/atoms/base-select-box/types';

type Options = IBaseSelectBoxOption<
  IClinicInvoiceBillingTypeItem['id'],
  IClinicInvoiceBillingTypeItem
>[];

interface IProps extends Omit<IBaseSelectBoxProps, 'options'> {}

const ClinicInvoiceBillingTypeSelectBox: React.FC<IProps> = (props) => {
  const dataSource = useMemo(() => clinicInvoiceBillingTypesDataSource(), []);

  const options: Options = useMemo(
    () =>
      dataSource.map((el) => ({
        value: el.id,
        label: el.name,
        record: el,
      })),
    [dataSource],
  );

  return <BaseSelectBox options={options} {...props} />;
};

export default ClinicInvoiceBillingTypeSelectBox;
